module.exports = __webpack_public_path__ + "media/images/map-icons/truck-348c4ceabe72b27852ff4e7a7a06af09.svg";